<template>
   <el-date-picker
    v-model="span"
    @change="handleTimesChange"
    :format="format"
    :type="type"
    :value-format="valueFormat"
    :start-placeholder="startPlaceholder"
    :end-placeholder="endPlaceholder"
    :default-time="['12:00:00']">
  </el-date-picker>
</template>
<script>
export default {
  name: 'DateRangeDestructor',
  props: {
    start: {
      type: String,
      required: true
    },
    end: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'datetimerange'
    },
    valueFormat: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss'
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss'
    },
    startPlaceholder: {
      type: String,
      default: '开始时间'
    },
    endPlaceholder: {
      type: String,
      default: '结束时间'
    }
  },
  watch: {
    start: {
      immediate: true,
      handler () {
        this.span = (this.start === '' && this.end === '') ? null : [this.start, this.end];
      }
    }
  },
  data() {
    return {
      span: null
    }
  },
  methods: {
    handleTimesChange(times) {
      if (times !== null) {
        this.$emit('update:start', times[0]);
        this.$emit('update:end', times[1]);
      } else {
        this.$emit('update:start', '');
        this.$emit('update:end', '');
      }
      this.$emit('change', times);
    }
  }
}
</script>